(function (jQuery) {
    "use strict";

    var $ = jQuery;

    var _getAppsOnSrcPage = function (uri, src, content, fn) { 
        var myconfig = {
            targetUrl: InFlight.NLX.Cfg.Customer.psBaseUrl() + uri,
            targetVerb: "GET",
            followProposedTemplate: false,
            showLoading: false,
            manualRequestObj: [
                { "Lbl": "menuItems", "Src": src, "Data": content, "Children": [] }
            ],
            callback: function (data) { 
                if (!data || !data.CaptureResults || !data.CaptureResults.menuItems || !data.CaptureResults.menuItems.length) {
                    fn([]);
                } else {
                    var keys = [];
                    $.each(data.CaptureResults.menuItems, function (i, element) {
                        keys.push(element.Properties.key);
                    });
                    fn(keys);
                }
            }
        };

        InFlightDC.init(myconfig);
    };

    var _getAppsOnSrcPages = function (srcPages, fn) {
        var srcPageRequestsCompleted = 0;
        var enabledAppsOnSrcPages = [];
        $.each(srcPages, function (i, srcPage) {
            _getAppsOnSrcPage(srcPage.uri, srcPage.src, srcPage.content, function (keys) {
                srcPageRequestsCompleted++;
                //flatten the list for easier searching later
                $.merge(enabledAppsOnSrcPages, keys);

                if (srcPageRequestsCompleted === srcPages.length) {
                    fn(enabledAppsOnSrcPages);
                }
            });
        });
    };

    var _isItemEnabledOnSrcPage = function (item, appsEnabledOnSrcPage) {
        for (var i = 0; i < appsEnabledOnSrcPage.length; i++) {
            if (appsEnabledOnSrcPage[i].indexOf(item.key) > -1) {
                return true;
            }
        }
        return false;
    };

    var _getAppsThatAreEnabled = function (apps, appsEnabledOnSrcPage) {
        $.each(apps, function (i, app) {
            app.items = $.grep(app.items, function (item, i) {
                return _isItemEnabledOnSrcPage(item, appsEnabledOnSrcPage);
            });
        });

        apps = $.grep(apps, function (app, i) {
            return app.items && app.items.length > 0;
        });

        return apps;
    };

    var deferred = [];

    InFlight.NLX.Cfg.Customer.getApps = function (_callback) {
        var sessionStorageKey = "__getAppsResult__";

        var callback = function (result) {
            var tmp = deferred;
            deferred = [];
            $.each(tmp, function (i, fn) {
                fn(result);
            });
        };

        deferred.push(_callback);
        if (deferred.length > 1) {
            return;
        }

        if (!sessionStorage.isLoggedIn) {
            void 0;
            sessionStorage.removeItem(sessionStorageKey);
            callback(null);
            return;
        }

        var cachedResult = sessionStorage.getItem(sessionStorageKey);

        if (cachedResult) {
            var parsedResult = JSON.parse(cachedResult);
            if (parsedResult !== null) {
                void 0;
                callback(parsedResult);
                return;
            }
        }

        $.getJSON(InFlight.NLX.Cfg.Customer.getAppsJson())
            .done(function (data) {
                var _resultHelper = function (result) {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(result));
                    callback(result);
                };

                if (!data.srcPages || !data.srcPages.length) {
                    void 0;
                    _resultHelper(data);
                    return;
                }

                _getAppsOnSrcPages(data.srcPages, function (appsEnabledOnSrcPages) {
                    var result = { "apps": _getAppsThatAreEnabled(data.apps, appsEnabledOnSrcPages) };
                    void 0;
                    _resultHelper(result);
                });
            })
            .fail(function (data) {
                void 0;
                sessionStorage.removeItem(sessionStorageKey);
                callback(null);
            });
    };
})(jQuery);
